"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeError = exports.addError = exports.isStartAfterEnd = exports.isOverlapingCue = exports.isEmptyCue = exports.validateTranscription = exports.hasErrors = exports.cleanTranscription = void 0;
var interfaces_1 = require("../interfaces");
exports.cleanTranscription = function (transcription, options) {
    if (options === void 0) { options = { ignoreErrors: false }; }
    return transcription
        .filter(function (cue) {
        var _a;
        if (options.ignoreErrors) {
            return true;
        }
        if ((_a = cue.metadata) === null || _a === void 0 ? void 0 : _a.errors) {
            return !cue.metadata.errors.length;
        }
        return true;
    })
        .map(function (cue) {
        return __assign(__assign({}, cue), { text: cleanCue(cue.text) });
    });
};
var cleanCue = function (value) {
    return value
        .replace(/&nbsp;/g, "") // Clean non breaking spaces
        .replace(/<(\/?)(mark|(mark class="(.+?|)"))>/g, ""); // Clean <mark> html tags from find & replace highlights
};
exports.hasErrors = function (transcription) {
    return transcription.some(function (c) { var _a, _b; return Boolean((_b = (_a = c.metadata) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.length); });
};
exports.validateTranscription = function (transcription) {
    return transcription
        .map(exports.isEmptyCue)
        .map(exports.isStartAfterEnd)
        .map(function (c, idx) { return exports.isOverlapingCue(transcription, c, idx)[1]; });
};
exports.isEmptyCue = function (cue) {
    if (cue.text == null || cue.text.trim() === "") {
        return exports.addError(cue, interfaces_1.CueError.Empty);
    }
    return exports.removeError(cue, interfaces_1.CueError.Empty);
};
// Returns the an array with 3 cues, the previous cue, the current cue, and the next cue.
// The previous and the next cue can be null if they don't exist in the transcription
exports.isOverlapingCue = function (transcription, cue, subtitleIdx) {
    var previousCue = subtitleIdx > 0 ? transcription[subtitleIdx - 1] : null;
    var nextCue = subtitleIdx + 1 < transcription.length
        ? transcription[subtitleIdx + 1]
        : null;
    var isOverlappingWithPrevious = previousCue && previousCue.end - 10 >= cue.start;
    var isOverlappingWithNext = nextCue && nextCue.start + 10 <= cue.end;
    if (isOverlappingWithPrevious) {
        cue = exports.addError(cue, interfaces_1.CueError.StartTimeOverlap);
        if (previousCue) {
            previousCue = exports.addError(previousCue, interfaces_1.CueError.EndTimeOverlap);
        }
    }
    else {
        cue = exports.removeError(cue, interfaces_1.CueError.StartTimeOverlap);
        if (previousCue) {
            previousCue = exports.removeError(previousCue, interfaces_1.CueError.EndTimeOverlap);
        }
    }
    if (isOverlappingWithNext) {
        cue = exports.addError(cue, interfaces_1.CueError.EndTimeOverlap);
        if (nextCue) {
            nextCue = exports.addError(nextCue, interfaces_1.CueError.StartTimeOverlap);
        }
    }
    else {
        cue = exports.removeError(cue, interfaces_1.CueError.EndTimeOverlap);
        if (nextCue) {
            nextCue = exports.removeError(nextCue, interfaces_1.CueError.StartTimeOverlap);
        }
    }
    return [previousCue, cue, nextCue];
};
exports.isStartAfterEnd = function (cue) {
    if (cue.start > cue.end) {
        cue = exports.addError(cue, interfaces_1.CueError.StartAfterEnd);
    }
    else {
        cue = exports.removeError(cue, interfaces_1.CueError.StartAfterEnd);
    }
    return cue;
};
exports.addError = function (cue, cueError) {
    var _a, _b;
    var cueErrors = (_b = (_a = cue.metadata) === null || _a === void 0 ? void 0 : _a.errors) !== null && _b !== void 0 ? _b : [];
    var errors = Array.from(new Set(__spreadArrays(cueErrors, [cueError])));
    return __assign(__assign({}, cue), { metadata: __assign(__assign({}, cue.metadata), { errors: errors }) });
};
exports.removeError = function (cue, cueError) {
    var _a, _b;
    var cueErrors = (_b = (_a = cue.metadata) === null || _a === void 0 ? void 0 : _a.errors) !== null && _b !== void 0 ? _b : [];
    var errors = cueErrors.filter(function (c) { return c !== cueError; });
    return __assign(__assign({}, cue), { metadata: __assign(__assign({}, cue.metadata), { errors: errors }) });
};
//# sourceMappingURL=validation.js.map